import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ttt from '@xingternal/ticktricktrack';

import { PAGEVIEW } from './helper';

const trackEvent = (event, baseData, contextData) => {
  if (event === PAGEVIEW) {
    // PropChannel and pageName are actually base data and have to be passed separately
    let { PropChannel, pageName, ..._contextData } = contextData;

    PropChannel = PropChannel || baseData.PropChannel || 'undefined';
    pageName = pageName || 'undefined';

    // prepend pageName with the channel if its not already the case
    if (pageName.indexOf(PropChannel) !== 0 || pageName === PropChannel) {
      pageName = `${PropChannel}/${pageName}`;
    }

    ttt.pageview(PropChannel, pageName, baseData, _contextData);
  } else {
    ttt.event(event, contextData);
  }
};

const createTrackingHoc = (event, baseData) => {
  return (argument) => (WrappedComponent) => {
    return class MaltTrackingHocComponent extends Component {
      static OriginalComponent = WrappedComponent;

      static displayName = `WithTracking(${
        WrappedComponent.displayName || WrappedComponent.name
      })`;

      static propTypes = {
        location: PropTypes.object,
      };

      componentDidUpdate(prevProps) {
        if (this.props.location === prevProps.location) {
          return;
        }

        this.track();
      }

      componentDidMount() {
        this.track();
      }

      track() {
        trackEvent(event, this.getBaseData(), this.getContextData());
      }

      getBaseData() {
        return typeof baseData === 'function' ? baseData() : baseData;
      }

      getContextData() {
        return typeof argument === 'function' ? argument(this.props) : argument;
      }

      render() {
        return <WrappedComponent {...this.props} />;
      }
    };
  };
};

export default createTrackingHoc;
